import SharedPropsService from '../../../SharedPropsService';
import { ButtonTypeTokens, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import _ from 'lodash';
import { api } from '../../../configs/api';
import { APP_CONFIG, getAppHeader } from '../../../configs/config';
import { SignDeskSDKUrl, } from '../../../configs/constants';
import { isMobile, nextStepCredStepper, } from '../../../configs/utils';
import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
let hasNavigated = false;
export const initiateESign = async (action, _datastore, { navigate, goBack, network, setDatastore, showPopup, analytics, instrumentTrack, navigateWithClear, navigateToBase, ...props }) => {
    console.warn("*** initiateESign action triggered ***", action);
    await setDatastore(ROUTE.SIGN_DESK_ESIGN, 'DigioAgreementPage', {
        loading: true,
        digioDeepCheckFailure: false,
    });
    if (Platform.OS === 'web') {
        await navigate(ROUTE.DIGIO_AGREEMENT_INPROGRESS);
    }
    const applicationId = (await SharedPropsService.getUser())
        .linkedApplications[0].applicationId;
    if (Platform.OS === "android" || Platform.OS === 'ios') {
        const esignResponse = await network.get(`${api.esignInit}${applicationId}`, {
            headers: await getAppHeader(),
        });
        let docketId = _.get(esignResponse, 'data.stepResponseObject.docketId');
        let documentId = _.get(esignResponse, 'data.stepResponseObject.documentId');
        let signId = _.get(esignResponse, 'data.stepResponseObject.signerIds[0]');
        let id = _.get(esignResponse, 'data.stepResponseObject.applicationId');
        await setDatastore(ROUTE.SIGN_DESK_ESIGN, 'DigioAgreementPage', {
            showWebView: true,
            docketId: docketId,
            documentId: documentId,
            id: id,
            signerId: signId,
            loading: false
        });
    }
    else {
        const response = await network.get(`${api.esignInit}${applicationId}`, {
            headers: await getAppHeader(),
            handleFromMF: true,
        });
        if (response?.status === 200) {
            var options = {
                id: response?.data?.stepResponseObject?.applicationId,
                docket_id: response?.data?.stepResponseObject?.docketId,
                signer_id: response?.data?.stepResponseObject?.signerIds[0],
                document_id: response?.data?.stepResponseObject?.documentId,
                //optional
                getWidgetToken: async function (result) {
                    const tokenResponse = await network.post(`${api.validateEsign}`, { widgetToken: result, applicationId: applicationId }, { headers: await getAppHeader() });
                },
                signatureStatus: async function (result) {
                    await setDatastore(ROUTE.SIGN_DESK_ESIGN, 'DigioAgreementPage', {
                        loading: false,
                    });
                    if (result.status === 'failed') {
                        await navigate(ROUTE.SIGN_DESK_ESIGN, {
                            digioDeepCheckFailure: true
                        });
                    }
                    else {
                        const response = await network.get(`${api.checkEsignStatus}${applicationId}`, { headers: await getAppHeader() });
                        if (response.status === 200) {
                            if (Platform.OS === "web") {
                                //@ts-ignore
                                window?.ReactNativeWebView?.postMessage("LOAN_CREATED");
                            }
                            const user = await SharedPropsService.getUser();
                            user.linkedApplications[0].currentStepId = _.get(response, 'data.updatedApplicationObj.currentStepId');
                            await SharedPropsService.setUser(user);
                            setTimeout(async () => {
                                const routeObj = await nextStepCredStepper();
                                if (!hasNavigated) {
                                    navigateWithClear(routeObj.routeId, routeObj.params);
                                }
                            }, 3000);
                            await navigate(ROUTE.SIGN_DESK_ESIGN, {
                                digioDeepCheckSuccess: true
                            });
                        }
                    }
                },
                errorLog: async function (result) {
                },
            };
            const script = document.createElement('script');
            script.src = SignDeskSDKUrl;
            document.body.appendChild(script);
            setTimeout(() => {
                // @ts-ignore
                const esignWidgetCall = window.esignWidgetCall;
                esignWidgetCall(options);
            }, 1000);
        }
        else {
            if (response?.response?.status === 400) {
                await navigate(ROUTE.SIGN_DESK_ESIGN);
                const errorMessage = response?.response?.data?.message;
                setTimeout(async () => {
                    await setDatastore(ROUTE.SIGN_DESK_ESIGN, 'DigioAgreementPage', {
                        showErrorCard: true,
                        loading: false,
                        errorMessage: errorMessage,
                    });
                }, 500);
            }
            else {
                await navigate(ROUTE.SIGN_DESK_ESIGN);
                setTimeout(async () => {
                    await setDatastore(ROUTE.SIGN_DESK_ESIGN, 'DigioAgreementPage', {
                        showErrorCard: true,
                        loading: false,
                        errorMessage: 'Something went wrong',
                    });
                }, 500);
            }
        }
    }
};
export const closeErrorModal = async (action, _datastore, { navigateWithClear, setDatastore }) => {
    await setDatastore(ROUTE.SIGN_DESK_ESIGN, 'DigioAgreementPage', {
        showErrorCard: false,
        loading: false,
        errorMessage: '',
        digioDeepCheckSuccess: undefined,
        digioDeepCheckFailure: undefined,
        updateProp: Math.random()
    });
};
export const NavigateNext = async (action, _datastore, { navigateWithClear }) => {
    hasNavigated = true;
    const routeObj = await nextStepCredStepper();
    console.log('Next object received is', routeObj);
    navigateWithClear(routeObj.routeId, routeObj.params);
};
export const handleAndroidCallback = async (action, _datastore, { goBack, navigateWithClear, network, setDatastore }) => {
    console.warn("*** handleAndroidCallback action triggered ***", action);
    const applicationId = (await SharedPropsService.getUser())
        .linkedApplications[0].applicationId;
    await setDatastore(ROUTE.SIGN_DESK_ESIGN, 'DigioAgreementPage', {
        showWebView: false,
    });
    //@ts-ignore
    if (action.payload.result === 'failed') {
        await setDatastore(ROUTE.SIGN_DESK_ESIGN, 'DigioAgreementPage', {
            digioDeepCheckFailure: true,
            updateProp: Math.random()
        });
    }
    else {
        const response = await network.get(`${api.checkEsignStatus}${applicationId}`, { headers: await getAppHeader() });
        if (response.status === 200) {
            const user = await SharedPropsService.getUser();
            user.linkedApplications[0].currentStepId = _.get(response, 'data.updatedApplicationObj.currentStepId');
            await SharedPropsService.setUser(user);
            const routeObj = await nextStepCredStepper();
            await setDatastore(ROUTE.SIGN_DESK_ESIGN, 'DigioAgreementPage', {
                digioDeepCheckSuccess: true,
                digioDeepCheckFailure: false,
                updateProp: Math.random()
            });
            setTimeout(() => {
                if (!hasNavigated) {
                    navigateWithClear(routeObj.routeId, routeObj.params);
                }
            }, 3000);
        }
    }
};
export const GoBackAction = async (action, _datastore, { goBack, navigateWithClear }) => {
    await navigateWithClear(ROUTE.KYC_STEPPER);
};
export const startKfsGeneration = async (action, _datastore, { goBack, network, navigateWithClear, setDatastore }) => {
    let shouldRunPollar = true;
    const user = await SharedPropsService.getUser();
    // @ts-ignoreb
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : user.linkedApplications[0].applicationId;
    network.get(`${api.pollKfsTata}${applicationId}`, { headers: await getAppHeader() }).then(async (response) => {
        console.warn("IN THE UPPER RESPONSE", response);
        if (response.data.stepResponseObject.status === "COMPLETED") {
            clearInterval(timer);
            console.warn("IN THE INSIDE", response.data.stepResponseObject);
            shouldRunPollar = false;
            if (isMobile() && Platform.OS === 'web') {
                window.open(response.data.stepResponseObject.s3Url, '_blank');
                await setDatastore(ROUTE.SIGN_DESK_ESIGN, 'DigioAgreementPage', {
                    kfsGeneraterLoading: false,
                    returnToBase: true,
                    updateProp: Math.random()
                });
            }
            else {
                if (Platform.OS === 'android') {
                    await setDatastore(ROUTE.SIGN_DESK_ESIGN, 'DigioAgreementPage', {
                        kfsGeneraterLoading: false,
                        kfsUrl: response.data.stepResponseObject.s3Url,
                        updateProp: Math.random()
                    });
                    setTimeout(async () => {
                        await setDatastore(ROUTE.SIGN_DESK_ESIGN, 'DigioAgreementPage', {
                            kfsGeneraterLoading: false,
                            returnToBase: true,
                            updateProp: Math.random()
                        });
                    }, 1000);
                }
                else {
                    await setDatastore(ROUTE.SIGN_DESK_ESIGN, 'DigioAgreementPage', {
                        kfsGeneraterLoading: false,
                        kfsUrl: response.data.stepResponseObject.s3Url,
                        updateProp: Math.random()
                    });
                }
            }
        }
    });
    // @ts-ignore
    const runPollar = async () => {
        network.get(`${api.pollKfsTata}${applicationId}`, { headers: await getAppHeader() }).then(async (response) => {
            if (!shouldRunPollar) {
                clearInterval(timer);
            }
            else {
                console.warn("IN THE UPPER RESPONSE", response);
                if (response.data.stepResponseObject.status === "COMPLETED") {
                    clearInterval(timer);
                    console.warn("IN THE INSIDE", response.data.stepResponseObject);
                    if (isMobile() && Platform.OS === 'web') {
                        window.open(response.data.stepResponseObject.s3Url, '_blank');
                        await setDatastore(ROUTE.SIGN_DESK_ESIGN, 'DigioAgreementPage', {
                            kfsGeneraterLoading: false,
                            returnToBase: true,
                            updateProp: Math.random()
                        });
                    }
                    else {
                        if (Platform.OS === 'android') {
                            await setDatastore(ROUTE.SIGN_DESK_ESIGN, 'DigioAgreementPage', {
                                kfsGeneraterLoading: false,
                                kfsUrl: response.data.stepResponseObject.s3Url,
                                updateProp: Math.random()
                            });
                            setTimeout(async () => {
                                await setDatastore(ROUTE.SIGN_DESK_ESIGN, 'DigioAgreementPage', {
                                    kfsGeneraterLoading: false,
                                    returnToBase: true,
                                    updateProp: Math.random()
                                });
                            }, 1000);
                        }
                        else {
                            await setDatastore(ROUTE.SIGN_DESK_ESIGN, 'DigioAgreementPage', {
                                kfsGeneraterLoading: false,
                                kfsUrl: response.data.stepResponseObject.s3Url,
                                updateProp: Math.random()
                            });
                        }
                    }
                }
            }
        });
    };
    const timer = setInterval(() => {
        runPollar();
    }, APP_CONFIG.POLLING_INTERVAL);
};
export const CallApi = async (action, _datastore, { goBack, network, navigateWithClear }) => {
    // @ts-ignoreb
    const applicationId = (await SharedPropsService.getUser())
        .linkedApplications[0].applicationId;
    // @ts-ignore
    const tokenResponse = await network.post(`${api.validateEsign}`, 
    // @ts-ignore
    { widgetToken: action.payload.result, applicationId: applicationId }, { headers: await getAppHeader() });
    console.warn("TOKEN RESPONSE IS HERE", tokenResponse);
};
export const contactUs = async (action, _datastore, { goBack, navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const ToggleKYCSummaryCTA = async (action, _datastore, { setDatastore }) => {
    await setDatastore(ROUTE.KYC_SUMMARY, 'continue', {
        type: action.payload.value
            ? ButtonTypeTokens.LargeFilled
            : ButtonTypeTokens.LargeOutline,
    });
};
